<template>
	<transition enter-active-class="fadeIn" leave-active-class="fadeOut">
		<div :class="`alert alert-${ type } alert-dismissible fade show`">
			<button type="button" aria-hidden="true" data-dismiss="alert" aria-label="Close" class="close">
				<i class="nc-icon nc-simple-remove"></i>
			</button>
			<span>
				<strong> {{ strongText }} - </strong> <span v-html="message"></span>
			</span>
		</div>
	</transition>
</template>

<script>
export default {
  name: "Alert",
  props: {
		type: String,
		message: String
	},
	computed: {
		strongText() {
			if(this.type === 'danger') {
				return 'Oops!'
			} else if(this.type === 'warning') {
				return 'Oh Snap!'
			} else if(this.type === 'success') {
				return 'Success'
			} else {
				return 'Please Note'
			}
		}
	}
};
</script>
